import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import MyPhoto from "../assets/images/myPhoto.jpg";

export default function Home() {
  const [showAbout, setShowAbout] = useState(false);

  useEffect(() => {
    document.title = "Jovana Mitic | Portfolio";
  }, []);

  const projects = [
    {
      id: "summer-jobs-greece",
      title: "Summer Jobs In Greece - Demo",
      description:
        "A portfolio demo of my live Summer Jobs In Greece platform, inspired by a Facebook community I built around seasonal work in Greece, now with over 27,000 members. The production version uses a .NET API, SQL database, authentication, Azure hosting, and a custom domain; this demo recreates the main job, blog, and account flows with local data.",
      note:
        "Demo built with React and TypeScript. Production app uses React, .NET API, SQL, Azure, and custom domain deployment.",
      link: "https://orange-dune-05787a710.7.azurestaticapps.net/",
    },
    {
      id: "quiz",
      title: "Memory Games App",
      description:
        "A mini-game collection featuring a card memory match, classic Simon Says, and a trivia quiz powered by the Trivia API.",
      note: "Built with React (TypeScript).",
      link: "https://jo1910.github.io/small-games-web/",
    },
    {
      id: "earthquake",
      title: "Earthquake Tracker",
      description:
        "Real-time seismic feed from USGS with simple location and magnitude filters.",
      note: "Built with React (TypeScript).",
      link: "https://jo1910.github.io/earthquake-tracker-web/",
    },
    {
      id: "weather",
      title: "Weather App",
      description:
            "Shows weather using OpenWeather API.",
      note: "Built with React (TypeScript) and Netlify Functions.",
      link: "https://feelsright-weather.netlify.app/",
    },
  ];

  return (
    <div className="min-h-screen bg-[#d0f0f8] dark:bg-[#150811] py-12 px-6">
      <div className="max-w-2xl mx-auto">
        {/* Profile Section */}
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="flex flex-col items-center mb-10"
        >
          <img
            src={MyPhoto}
            alt="Jovana Mitic"
            className="w-28 h-28 rounded-full mb-4 object-cover"
          />
          <motion.h1
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2 }}
            className="text-2xl sm:text-3xl font-bold text-center text-[#1b0036] dark:text-[#f1f1f1]"
          >
            Jovana Mitic
          </motion.h1>
          <p className="text-base text-[#380036] dark:text-[#9DCDC0] mt-1">
            Full-Stack Software Developer
          </p>

          {/* About Toggle */}
          <button
            onClick={() => setShowAbout(!showAbout)}
            className="mt-3 text-[#00a7a7] dark:text-[#F4EF88] hover:underline focus:outline-none"
          >
            {showAbout ? "Hide About ▲" : "About ▼"}
          </button>

          {/* About Text */}
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{
              opacity: showAbout ? 1 : 0,
              height: showAbout ? "auto" : 0,
            }}
            transition={{ duration: 0.4 }}
            className="overflow-hidden mt-3 text-sm text-center text-[#380036] dark:text-[#9DCDC0] max-w-md"
          >
            <p>
              I’m a full-stack software developer passionate about creating
              clean, efficient, and user-friendly applications. I work with{" "}
              <strong>.NET</strong> for backend development,{" "}
              <strong>SQL Server</strong> for data management, and build
              interactive UIs using <strong>React.js</strong> and{" "}
              <strong>AngularJS</strong>. I’ve also worked with{" "}
              <strong>React Native</strong> for mobile apps and recently started
              exploring <strong>Next.js</strong> to expand my full-stack
              capabilities.
            </p>
          </motion.div>
        </motion.div>

        {/* Projects */}
        <h2 className="text-2xl font-bold text-[#1b0036] dark:text-[#f1f1f1] mb-2">
          My Recent Projects
        </h2>
        <p className="text-sm text-[#380036] dark:text-[#9DCDC0] mb-6">
          Below are a few of my projects — I’ll be adding more soon!
        </p>

        <div className="space-y-4">
          {projects.map((project, i) => (
            <motion.div
              key={project.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 + i * 0.15 }}
              className="bg-[#b3f0e2] dark:bg-[#26081C] rounded-xl p-5 shadow-md"
            >
              <a href={project.link}>
                <h3 className="text-lg font-bold mb-1 text-[#1b0036] dark:text-[#f1f1f1]">
                  {project.title}
                </h3>
                <p className="text-sm text-[#380036] dark:text-[#9DCDC0] mb-1">
                  {project.description}
                </p>
                {project.note && (
                  <p className="text-xs italic text-[#007070] dark:text-[#C0E8E0]">
                    {project.note}
                  </p>
                )}
              </a>
            </motion.div>
          ))}
        </div>

        {/* Contact */}
        <div className="mt-16 text-center">
          <h3 className="text-xl font-semibold mb-3 text-[#1b0036] dark:text-[#f1f1f1]">
            Contact
          </h3>
          <a
            href="mailto:jovanamitic@pm.me"
            className="text-base text-[#00a7a7] dark:text-[#F4EF88] hover:underline"
          >
            jovanamitic@pm.me
          </a>
        </div>
      </div>
    </div>
  );
}
